module.exports = __webpack_public_path__ + "media/customizations/simplyartavia/back-3f020076492fb0981717379d51b42463.jpg";